<div class="flex flex-col gap-4">
  <header class="flex flex-row items-center justify-between ">
    <h1 class="text-3xl font-bold text-[color:var(--text-color)]">{{ 'financePages.balancesTitle' | translate }}</h1>
  </header>

  <bo-balances-kpi-list [kpisFromParent]="kpis()" />

  <bo-organizer-balances></bo-organizer-balances>
</div>
